module.exports = __webpack_public_path__ + "static/rapsodia-caf441610ff3d24ce74768c02e460970.jpg";